
import { Injectable } from '@angular/core';
import {

  ActionDTO,
  ActionTypeDTO,
  LinkedActionsDTO
} from '../../app/api/plyca-dtos';
import { PlycaDataService } from '../../services/plyca.service';


@Injectable()
export class ActionService {

  constructor(
    public plycaService: PlycaDataService

  ) {


  }

  // Funciones de visualizació de acciones en distintos componentes y pantallas
  public updateProperty(propertyPath: string, event: any): void {
    // objectPath.set(action, propertyPath, event);
  }

  public getActionClass(action: ActionDTO): string {
    let cssClass = '';
    switch (action.identifier) {
      case ActionTypeDTO.TASK_UNLOCK: {
        cssClass = 'btn-warning';
        break;
      }
      case ActionTypeDTO.TASK_MANTAIN: {
        cssClass = 'btn-warning';
        break;
      }
      default: {
        cssClass = 'btn-primary';
        break;
      }
    }

    return cssClass;
  }

  public getActionIconClass(action: ActionDTO): string {
    let cssClass = '';
    switch (action.identifier) {
      case ActionTypeDTO.TASK_UNLOCK: {
        cssClass = 'fas fa-unlock';
        break;
      }
      case ActionTypeDTO.TASK_MANTAIN: {
        cssClass = 'fas fa-unlock';
        break;
      }
      case ActionTypeDTO.TASK_DISPATCH: {
        cssClass = 'fas fa-check';
        break;
      }
      case ActionTypeDTO.PROCEDURE_CANCEL: {
        cssClass = 'fas fa-ban';
        break;
      }
      case ActionTypeDTO.READJUST_PROCEDURE: {
        cssClass = 'fa fa-random';
        break;
      }
      case ActionTypeDTO.SET_PROCEDURE_VARIABLES: {
        cssClass = 'fa fa-server';
        break;
      }
      case ActionTypeDTO.SET_TASK_VARIABLES: {
        cssClass = 'fa fa-server';
        break;
      }

      case ActionTypeDTO.PROCEDURE_REPAIR: {
        cssClass = 'fas fa-play';
        break;
      }

      case ActionTypeDTO.DOC_GENERATE_CA: {
        cssClass = 'fas fa-ca';
        break;
      }

      case ActionTypeDTO.DOC_CORRECT_DOCUMENT: {
        cssClass = 'fas fa-undo-alt text-danger';
        break;
      }
      case ActionTypeDTO.DOC_RENAME: {
        cssClass = 'fas fa-pencil-alt';
        break;
      }
      case ActionTypeDTO.RULE_CANCEL: {
        cssClass = 'fas fa-ban';
        break;
      }
      case ActionTypeDTO.DOC_CANCEL: {
        cssClass = 'fas fa-times';
        break;
      }
      case ActionTypeDTO.RULE_CANCEL: {
        cssClass = 'fas fa-ban';
        break;
      }
      case ActionTypeDTO.IMPORT_COMPANY: {
        cssClass = 'fas fa-file-import';
        break;
      }
      case ActionTypeDTO.IMPORT_INVOICE: {
        cssClass = 'fas fa-file-import';
        break;
      }
      case ActionTypeDTO.CHANGE_STATUS_SITUATION: {
        cssClass = 'fas fa-wrench';
        break;
      }
      case ActionTypeDTO.ORGANIZATIONALUNIT_PUBLISH: {
        cssClass = 'far fa-paper-plane';
        break;
      }
      case ActionTypeDTO.ORGANIZATIONALUNIT_CHANGELOCATION: {
        cssClass = 'fas fa-sitemap';
        break;
      }
      case ActionTypeDTO.OPEN_TENDERCLASSIFICATION: {
        cssClass = 'fas fa-lg fa-list-ol';
        break;
      }
      case ActionTypeDTO.OPEN_PROCUREMENTPROJECTLOTSTATEINFO: {
        cssClass = 'fas fa-list-ul';
        break;
      }
      case 'EXPORT_TENDER_REQUESTEDMATERIAL': {
        cssClass = 'fas fa-file-export';
        break;
      }
      case 'IMPORT_TENDER_REQUESTEDMATERIAL': {
        cssClass = 'fas fa-file-import';
        break;
      }
      case 'EXPORT_AWARD_REQUESTEDMATERIAL': {
        cssClass = 'fas fa-file-export';
        break;
      }
      case 'IMPORT_AWARD_REQUESTEDMATERIAL': {
        cssClass = 'fas fa-file-import';
        break;
      }
      case 'EXPORT_CONTRACT_REQUESTEDMATERIAL': {
        cssClass = 'fas fa-file-export';
        break;
      }
      case 'IMPORT_CONTRACT_REQUESTEDMATERIAL': {
        cssClass = 'fas fa-file-import';
        break;
      }
      default: {
        cssClass = '';
        break;
      }
    }

    return cssClass;

  }

  public getActiveActions(
    actions: LinkedActionsDTO,
    filterFunction?: Function
  ): LinkedActionsDTO {
    let activeActions: LinkedActionsDTO = new LinkedActionsDTO();
    activeActions.actions = new Array();
    activeActions.parameters = actions.parameters;
    console.log(filterFunction);
    actions.actions
      .filter((action: ActionDTO) => action.enabled)
      .filter((action: ActionDTO) =>
        filterFunction ? filterFunction.call(this, action) : true
      )
      .forEach((action: ActionDTO) => activeActions.actions.push(action));
    return activeActions;
  }
}
